// @flow
import * as React from 'react';
import {
    Layer, Box, Heading, Button, Text,
} from 'grommet';
import RedButton from 'esm-web-pro/components/layout/RedButton';
import GreenButton from 'esm-web-pro/components/layout/GreenButton';


type Props = {
    message?: string | React.Node,
    title?: ?string | React.Node,
    actions: {
        [string]: {
            label: string | React.Node,
            type?: 'positive' | 'negative',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => void,
            [string]: any,
        }
    },
    actionsAlign: string,
    position: string,
    size: string,
}


const MessageDialog = (props: Props) => {
    const {
        message, title, actions, position, actionsAlign, size,
    } = props;

    return (
        <Layer position={position} modal zIndex={1000}>
            <Box width={size} pad="small">
                {title && (
                    <Box flex={false} direction="row" justify="between" margin={{ bottom: 'small' }}>
                        <Heading level={5} margin="none">{title}</Heading>
                    </Box>
                )}
                <Text textAlign="center">
                    {message}
                </Text>
                <Box justify={actionsAlign} margin={{ top: 'small' }} direction="row" gap="small">
                    {Object.keys(actions).map((name) => {
                        const {
                            label, callback, type, ...rest
                        } = actions[name];

                        if (type === 'negative') {
                            return (
                                <Box key={name} dirextion="row" height="32px">
                                    <RedButton
                                        fill
                                        label={label}
                                        alignSelf="end"
                                        onClick={callback}
                                        color="status-error"
                                        {...rest}
                                    />
                                </Box>
                            );
                        }

                        return (
                            <Box key={name} dirextion="row" height="32px">
                                <GreenButton
                                    fill
                                    label={label}
                                    alignSelf="end"
                                    onClick={callback}
                                    {...rest}
                                />
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </Layer>
    );
};


MessageDialog.defaultProps = {
    title: null,
    message: null,
    actions: {},
    position: 'center',
    actionsAlign: 'center',
    size: 'medium',
};

export default MessageDialog;
